'use client'

// Third-party Imports
import classnames from 'classnames'
import dayjs from 'dayjs'
import 'dayjs/locale/id'
dayjs.locale('id')
import { useEffect, useState } from 'react'

// Util Imports
import { verticalLayoutClasses } from '@layouts/utils/layoutClasses'

const FooterContent = () => {
  const [currentTime, setCurrentTime] = useState(dayjs().format('DD MMM YYYY HH:mm:ss'))

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(dayjs().format('DD MMM YYYY HH:mm:ss'))
    }, 1000)

    return () => clearInterval(timer)
  }, [])

  return (
    <div
      className={classnames(
        verticalLayoutClasses.footerContent,
        'flex items-center justify-end flex-wrap gap-4 w-full'
      )}
    >
      <span className='font-bold text-primary' style={{ fontSize: '3vh' }}>
        {currentTime}
      </span>
    </div>
  )
}

export default FooterContent
